// extracted by mini-css-extract-plugin
export default {"container":"Nav_container__A9FAB","back":"Nav_back__drhHH","flex":"Nav_flex__ZNy2r","logo":"Nav_logo__QR8zV","img":"Nav_img__tDcjb","title":"Nav_title__rU6zu"};